import actions from "./actionTypes";
import config from "../../../config/config";

const {
  REQUEST_REPORTS,
  RECIEVE_REPORTS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
} = actions;

function hasError(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors,
  };
}


export function fecthReports(token) {
  return fetch(`${config.URI}/api/v1/reports`, {
    headers: {
      "Authenticity-Token": token,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw Error(res.statusText)
    }
  });
}

export function getReports(token) {
  return function(dispatch) {
    dispatch({ type: REQUEST_REPORTS });
    fecthReports(token).then(res => {
      if(res && res.status && res.status === 'success') {
        dispatch({ type: RECIEVE_REPORTS, reports: res.data.reports});
      } else {
        console.error(res.errors);
      }
    }).catch(error => {
      dispatch(hasError(error));
      console.error(error);
    })
  }
}

export function clearErrors() {
  return function(dispatch) {
    dispatch({ type: CLEAR_ERRORS });
  }
}




// WEBPACK FOOTER //
// src/routes/ProblemReports/actions/index.js